import { render, staticRenderFns } from "./KurccNotFoundPage.vue?vue&type=template&id=038f70bb&scoped=true&"
import script from "./KurccNotFoundPage.vue?vue&type=script&lang=js&"
export * from "./KurccNotFoundPage.vue?vue&type=script&lang=js&"
import style0 from "./KurccNotFoundPage.vue?vue&type=style&index=0&id=038f70bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038f70bb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
